<template>
    <ul v-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <router-link :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div :class="className + '__link gnb__link--toggle d-xl-none'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link :to="item.path" :class="className + '__link gnb__link--toggle d-none d-xl-flex'">
                    <h2>{{ item.title }}</h2>
                </router-link>
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.to">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
    },
    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "회사소개",
                    path: "/company/greeting",
                    children: [
                        {
                            title: "인사말",
                            to: "/company/greeting",
                        },
                        {
                            title: "연혁",
                            to: "/company/history",
                        },
                        {
                            title: "파트너 거래처",
                            to: "/company/partners",
                        },
                        {
                            title: "오시는 길",
                            to: "/company/contact",
                        },
                    ],
                },
                {
                    title: "비즈니스",
                    path: "/business/overview",
                    children: [
                        {
                            title: "사업개요",
                            to: "/business/overview",
                        },
                        {
                            title: "비전&미션",
                            to: "/business/vnm",
                        },
                        {
                            title: "프로세스",
                            to: "/business/process",
                        },
                    ],
                },
                {
                    title: "제품안내",
                    path: "/product",
                    children: [
                        {
                            title: "소스류(OEM가능)",
                            to: { path: "/product", hash: "1" },
                        },
                        {
                            title: "제과제빵류",
                            to: { path: "/product", hash: "2" },
                        },
                        {
                            title: "공산품식자재류",
                            to: { path: "/product", hash: "3" },
                        },
                        {
                            title: "치즈 및 유제품류",
                            to: { path: "/product", hash: "4" },
                        },
                        {
                            title: "파스타면 외 면류",
                            to: { path: "/product", hash: "5" },
                        },
                        {
                            title: "냉동/냉장가공 식품류",
                            to: { path: "/product", hash: "6" },
                        },
                        {
                            title: "육가공류 및 포장육류",
                            to: { path: "/product", hash: "7" },
                        },
                        {
                            title: "아채/신선식품류",
                            to: { path: "/product", hash: "8" },
                        },
                    ],
                },
                {
                    title: "고객센터",
                    path: "/service/inquiry",
                    children: [
                        {
                            title: "상담문의",
                            to: "/service/inquiry",
                        },
                        {
                            title: "공지사항",
                            to: "/service/notice",
                        },
                        {
                            title: "자주 묻는 질문",
                            to: "/service/question",
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function() {},
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>
